import { authApi } from 'api';
import { InvoiceItem } from 'api/shop/invoice-item/dtos';
import { Invoice } from 'api/shop/invoice/dtos';
import { StudentBalance, StudentSelf } from 'api/student/dtos';
import { Invitation } from '../invitation/dtos';
import { CreateStudentSelfRequest, SelfUser } from './dtos';

export const getSelf = async () => {
  return authApi.get<SelfUser>(undefined, '/me');
};

export const listSelfInvitations = async () => {
  return authApi.get<Invitation[]>(undefined, '/me/invitations');
};

export const getStudentSelf = async (studentId: number) => {
  return authApi.get<StudentSelf>(undefined, `/me/student/${studentId}`);
};

export const getStudentSelfInvoices = async (studentId: number) => {
  return authApi.get<Invoice[]>(undefined, `/me/student/${studentId}/invoices`);
};

export const getStudentSelfInvoiceItems = async (studentId: number) => {
  return authApi.get<InvoiceItem[]>(undefined, `/me/student/${studentId}/invoice-items`);
};

export const getAllStudentsSelf = async () => {
  return authApi.get<StudentSelf[]>(undefined, `/me/student`);
};

export const createStudentSelf = async (data: CreateStudentSelfRequest) => {
  const { businessId, ...rest } = data;
  return authApi.post<StudentSelf>(undefined, `/me/student/${businessId}`, { body: rest });
};

export const updateStudentSelf = async (studentId: number, data: CreateStudentSelfRequest) => {
  const { businessId, ...rest } = data;

  return authApi.put<StudentSelf>(undefined, `/me/student/${studentId}`, { body: rest });
};

export const getStudentSelfBalance = async (studentId: number) => {
  return authApi.get<StudentBalance>(undefined, `/me/student/${studentId}/balance`);
};

export const getStudentSelfSignature = async (studentId: number) => {
  return authApi.get<string>(undefined, `/me/student/${studentId}/signature`);
};
